import { FaInstagram, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import { smoothScroll } from '../utils/smoothScroll';
import './Footer.css';

const Footer = () => {
  const handleScroll = (e, targetId) => {
    e.preventDefault();
    smoothScroll(targetId);
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-column brand-column">
          <h3>Dra. Walquiria Ramirez</h3>
          <p className="footer-tagline">Médica Clínica</p>
          <p className="footer-description">
            Atención médica personalizada enfocada en la prevención, el diagnóstico y el tratamiento integral del adulto en Tandil.
          </p>
        </div>

        <div className="footer-column links-column">
          <h4>Enlaces Rápidos</h4>
          <ul>
            <li><a href="#home" onClick={(e) => handleScroll(e, '#home')}>Inicio</a></li>
            <li><a href="#consult" onClick={(e) => handleScroll(e, '#consult')}>Cuándo consultar</a></li>
            <li><a href="#booking" onClick={(e) => handleScroll(e, '#booking')}>Pedir turno</a></li>
            <li><a href="#about" onClick={(e) => handleScroll(e, '#about')}>Sobre Mí</a></li>
          </ul>
        </div>

        <div className="footer-column contact-column">
          <h4>Contacto</h4>
          <div className="contact-item">
            <FaMapMarkerAlt className="footer-icon" />
            <span>Tandil, Buenos Aires</span>
          </div>
          {/* <div className="contact-item">
            <FaEnvelope className="footer-icon" />
            <span>contacto@drawalquiria.com</span>
          </div> */}
          <div className="social-links">
            <a href="https://www.instagram.com/dra.walquiriaramirez/" target="_blank" rel="noopener noreferrer" className="social-link">
              <FaInstagram /> <span>@dra.walquiriaramirez</span>
            </a>
            <a href="mailto:dra.walquiriaramirez@gmail.com" target="_blank" rel="noopener noreferrer" className="social-link">
              <FaEnvelope /> <span>dra.walquiriaramirez@gmail.com</span>
            </a>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} Dra. Walquiria Ramirez. Todos los derechos reservados.</p>
      </div>
    </footer>
  );
};

export default Footer;
